import React, { useEffect } from "react";
import "./Styles/productCard.css"
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import StarIcon from '@mui/icons-material/Star';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import { priceFr } from "../Services/Numbers";
import { isProductInCart, getCart, setCart, addProductInCart, addProductInFavourites, getFavourites, isProductInFavourites } from '../Services/localStorage';
import { useState } from 'react';
import Cookies from 'universal-cookie';

export default function ProductCard({ product = {} }) {

    const productsURL = process.env.REACT_APP_API_BASE_URL + '/images/products/';

    useEffect(() => {
        setInFav(isProductInFavourites(product.id))
        setInCart(isProductInCart(product.id))
    })

    const cookies = new Cookies();

    const [inFav, setInFav] = useState(false)
    const [inCart, setInCart] = useState(false)

    let stars = [];
    for (let i = 0; i < product.stars; i++) {
        stars.push(<StarIcon key={'full-star_' + product.slug + '_' + (i + 1)} sx={{ color: 'gold', fontSize: '20px' }} />);
    }

    if (product.stars < 5) {
        for (let i = 0; i < 5 - product.stars; i++) {
        stars.push(<StarOutlineIcon key={'empty-star_' + product.slug + '_' + (i + 1)} sx={{ color: 'gold', fontSize: '20px' }} />);
        }
    }

    let prices = '';
    let badge = '';

    if (product.discount) {
        let oldPrice = product.price;
        let newPrice = oldPrice - Math.round(oldPrice * product.discount / 100)
        prices = (<>
            <small>{priceFr(oldPrice)} F</small><br/>{priceFr(newPrice)} F
        </>)

        badge = <span className="pc-badge">-{product.discount}%</span>
    }
    else {
        prices = (<>
            {priceFr(product.price)} F
        </>)
    }

    const addToCart = () => {
        addProductInCart(product, 1)
        setInCart(isProductInCart(product.id))
    }

    const addToFav = () => {
        addProductInFavourites(product)
        setInFav(isProductInFavourites(product.id))
    }
    
  return (
    <div className="pc-card">
        {badge}
        <a href={"/boutique/"+product.slug} className="pc-tumb">
            <img src={productsURL + product.thumb} alt=""/>
        </a>
        <div className="pc-details">
            <span className="pc-catagory">{product.category.name}</span>
            <h4><a href={"/boutique/"+product.slug}>{product.name}</a></h4>
            <p>
                {stars}
            </p>
            <div className="pc-bottom-details">
                <div className="pc-price">{prices}</div>
                <div className="pc-links">
                    {
                    inCart ?
                        cookies.get('user') ?
                            (
                                <span onClick={() => { addToCart() }}><ShoppingCartIcon sx={{ color: "#80377D", fontSize: '25px'}} /></span>
                            )
                        :
                            (
                                <span onClick={() => { addToCart() }}><ShoppingCartIcon sx={{ color: "#80377D", fontSize: '25px'}} /></span>
                            )
                    :
                        cookies.get('user') ?
                            (
                                <span className="clickable" onClick={() => { addToCart() }}><AddShoppingCartIcon sx={{ color: "#80377D", fontSize: '25px'}} /></span>
                            )
                        :
                            (
                                <span className="clickable" onClick={() => { addToCart() }}><AddShoppingCartIcon sx={{ color: "#80377D", fontSize: '25px', borderColor: '#80377D'}} /></span>
                            )
                    }

                    {
                    cookies.get('user') ?
                        inFav ?
                            (
                                <span><FavoriteIcon sx={{ color: "#ba0001", fontSize: '25px' }} /></span>
                            )
                        :
                            (
                                <span onClick={() => { addToFav() }} className="clickable"><FavoriteBorderIcon sx={{ color: "#ba0001", fontSize: '25px' }} /></span>
                            )
                    : ''
                    }

                </div>
            </div>
        </div>
    </div>
  );
}